import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Topsection from "./Topsection";
import Rightside from "./Rightside";
import FloatingButton from "./FloatingButton";
import Mobilefooterbtn from "./Mobilefooterbtn";

import { Helmet } from 'react-helmet';

const Contact = () => {
  const courseOptions = [
    { value: "AWS Cloud & DevOps", label: "AWS Cloud & DevOps" },
    { value: "Data Analytics", label: "Data Analytics" },
    { value: "Data Science", label: "Data Science" },
    { value: "Cyber Security", label: "Cyber Security" },
    { value: "Full Stack JAVA", label: "Full Stack JAVA" },
    { value: "Full Stack .NET", label: "Full Stack .NET" },
    { value: "Full Stack Python", label: "Full Stack Python" },
    { value: "MERN Stack", label: "MERN Stack" },
    { value: "Software Testing", label: "Software Testing" },
    { value: "Android Development", label: "Android Development" },
    { value: "Digital Marketing", label: "Digital Marketing" },
    { value: "Internship programs", label: "Internship programs" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    branch: "",
    course: [],
  });

  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const showOtherCourse = formData.course === "Other";

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    } else if (!/^[A-Za-z ]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can contain only letters and spaces.";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }

    if (!formData.contact.trim()) {
      newErrors.contact = "Contact is required.";
    } else if (!/^\d{10}$/.test(formData.contact)) {
      newErrors.contact = "Contact must be 10 digits.";
    }

    if (!formData.course.length) {
      newErrors.course = "Please select at least one course.";
    }

    if (!formData.branch) {
      newErrors.branch = "Branch selection is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
  if (!validateForm()) return;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/enquiries`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          course: formData.course.join(", "),
        }),
      }
    );

    const result = await response.json();

    if (response.status === 409) {
      alert("An enquiry already exists with this email or contact.");
    } else if (response.ok) {
      alert("Enquiry submitted!");
      setFormData({
        name: "",
        email: "",
        contact: "",
        branch: "",
        course: [],
      });
    } else {
      alert(result.error || "Failed to submit enquiry");
    }
  } catch (err) {
    console.error(err);
    alert("Error submitting enquiry");
  }
};


  return (
    <div>
      <Helmet>
          <title>Fortune Cloud Technologies | Contact</title>
          <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
          <meta name="robots" content="index, follow" />
      </Helmet>

      <Topsection />
      <Header />

      <div className="courseslinear">
        <div className="text-center mb-4 bgcolor1 pt-4 ps-4 pe-4 pb-1">
          <p className="text-white fs-4">
            Empowering the next generation of tech professionals through
            hands-on training and real-world experience.
            {/* The positive thinker sees the invisible, Feels the intangible & achieves the Impossible */}
          </p>
        </div>

        {/* <h1 className="text-center m-4 text-dark title1">Contact Us</h1> */}
        <div className="container">
          <div className="col-12 col-lg text-dark lead text-justify">
            <div className="row gy-4">
              <div className="col align-start-center flex-wrap animate__animated animate__slow animate__fadeInDown">
                <strong>
                  <h1 className="text-center text-dark title1">Get In Touch</h1>
                </strong>
                <strong>
                  {" "}
                  <div className="text-dark fw-bold text-center">
                    Leave your query and we’ll reach out to you.For admissions
                    related query, our expert learning consultant will help you
                    carve a career path for you.
                    <br />
                    <br />
                    {/* <p className=" mt-2 h6">
                        <a href="#" class="text-dark text-decoration-none lead">
                          <i class="bi bi-envelope-fill"></i>{" "}
                          <strong> info@fortunecloudindia.com</strong>
                        </a>
                      </p>
                      <p className="h6">
                        <a
                          href="tel:+91-9032439090"
                          class="text-dark text-decoration-none lead"
                        >
                          <i class="bi bi-telephone-fill"></i>{" "}
                          <strong> +91 -9032439090</strong>
                        </a>
                      </p> */}
                  </div>
                </strong>
              </div>
            </div>
          </div>
          <div className="row align-items-center  ms-3 me-3">
            {/* Form  Column */}
            <div className="border border-2 col-12 col-lg-4 mt-4 mt-lg-0 p-4 rounded shadow p-3 mb-5 rounded courseslinear animate__animated animate__slow animate__fadeInLeft">
              <form onSubmit={(e) => e.preventDefault()}>


                <select
                  name="branch"
                  className="form-control pb-3 mb-2"
                  value={formData.branch}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Branch
                  </option>
                  <option value="Shivajinagar, Pune">Shivajinagar, Pune</option>
                  <option value="Pimpri-Chinchwad, Pune">
                    Pimpri-Chinchwad, Pune
                  </option>
                  <option value="Bengaluru/Bangalore">
                    Bengaluru/Bangalore
                  </option>
                </select>
                {errors.branch && (
                  <small className="text-danger">{errors.branch}</small>
                )}



                <div className="mb-2" ref={dropdownRef}>
                  <div className="dropdown">
                    <button
                      type="button"
                      className="form-control text-start"
                      onClick={() => setDropdownOpen((prev) => !prev)}
                    >
                      {formData.course.length > 0
                        ? formData.course.join(", ")
                        : "Select Course(s)"}
                    </button>

                    {dropdownOpen && (
                      <div
                        className="dropdown-menu show p-2 border w-100"
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        {courseOptions.map((option) => (
                          <div className="form-check" key={option.value}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={option.value}
                              value={option.value}
                              checked={formData.course.includes(option.value)}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setFormData((prev) => {
                                  const newCourses = isChecked
                                    ? [...prev.course, option.value]
                                    : prev.course.filter(
                                        (val) => val !== option.value
                                      );
                                  return { ...prev, course: newCourses };
                                });
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={option.value}
                            >
                              {option.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {errors.course && (
                    <small className="text-danger">{errors.course}</small>
                  )}
                </div>


                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  className="form-control pb-3 mb-2"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}

                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  className="form-control pb-3 mb-2"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}

                <input
                  type="number"
                  name="contact"
                  placeholder="Enter your contact"
                  className="form-control pb-3 mb-2"
                  value={formData.contact}
                  onChange={handleChange}
                />
                {errors.contact && (
                  <small className="text-danger">{errors.contact}</small>
                )}

                

                

                <div className="d-grid pb-3 mb-2">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
            {/* Address Column */}
            {/* <div className="col-12 col-lg-1"></div> */}
            <div className="col-12 col-lg-8 p-3">
              <div className="row gy-4">
                {[
                  {
                    title: "Head Office",
                    address:
                      "3rd Floor, Abhinav Apartment, Next To Congress Bhavan, Above Pai Clinic, Shivaji Nagar, Pune, Maharashtra 411005.",
                    phone: "+91 9766439090",
                    email: "info@fortunecloudindia.com",
                    map: "https://g.page/fortunecloud/",
                  },
                  {
                    title: "Corporate Office",
                    address:
                      "2nd Floor, Shirodkar House, Opposite to Amit Cafe, Congress House Road, Near Pune Municipal Corporation, Shivajinagar, Pune - 411005",
                    phone: "+91 9032439090",
                    email: "info@fortunecloudindia.com",
                    map: "https://g.page/r/CZf_tsH8HKRuEBM/",
                  },
                  {
                    title: "Pimpri Office",
                    address:
                      "7th Floor, Office No - 704 to 707, Bramha Sky Uzuri, Opposite to PCMC BUILDING, Pimpri, Pune - 411018.",
                    phone: "+91 8002949090",
                    email: "fortunecloudPimpri@gmail.com",
                    map: "https://maps.app.goo.gl/Vg5eK7wMza5yciEM9",
                  },
                  {
                    title: "Bengaluru Office",
                    address:
                      "Ground Floor, Mathrushree Arcade, BTM Stage 2, 1st phase, BTM layout, Rashtrakavi Kuvempu Nagar, Bengaluru - 560076.",
                    phone: "+91 7090119090",
                    email: "info@fortunecloudindia.com",
                    map: "https://maps.app.goo.gl/3SbRfZ1DkVCPcPxi6",
                  },
                ].map((office, index) => (
                  <div className="col-12 col-md-6" key={index}>
                    <div className="border border-5 rounded p-3 shadow bgcolorcontact2 h-100">
                      <div className="fw-bold mb-2 fs-5">
                        <i className="bi bi-building me-2 text-primary"></i>
                        {office.title}
                      </div>
                      <div className="mb-2">
                        <i className="bi bi-geo-alt-fill me-2"></i>
                        <a
                          href={office.map}
                          target="_blank"
                          rel="noreferrer"
                          className="text-decoration-none text-dark"
                        >
                          <p className="mb-0">{office.address}</p>
                        </a>
                      </div>
                      <div className="mb-2">
                        <i className="bi bi-telephone-fill me-2"></i>
                        <a
                          href={`tel:${office.phone.replace(/[^+\d]/g, "")}`}
                          className="text-decoration-none text-dark"
                        >
                          {office.phone}
                        </a>
                      </div>
                      <div>
                        <i className="bi bi-envelope-fill me-2"></i>
                        <a href={`mailto:${office.email}`}>{office.email}</a>
                        
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* <hr /> */}
      </div>

      <Footer />
      <FloatingButton />
      <Mobilefooterbtn />
    </div>
  );
};

export default Contact;
